<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="2" fill="#F09E00"/>
    <g clip-path="url(#clip0)">
      <path d="M5.95602 10.4894C5.61546 11.1589 6.00213 11.4789 6.88435 12.0256C7.63435 12.4889 8.67046 12.6583 9.33602 12.7261C9.06324 12.9883 10.3132 11.7861 6.71324 15.2489C5.94991 15.9806 7.17879 17.1545 7.94157 16.4383L10.0066 14.4467C10.7971 15.2072 11.5549 15.9361 12.0716 16.4411C12.8349 17.16 14.0632 15.9961 13.3082 15.2517C13.2516 15.1978 10.5099 12.5678 10.6771 12.7289C11.351 12.6611 12.3716 12.4817 13.1127 12.0283L13.1121 12.0278C13.9943 11.4783 14.381 11.1589 14.0455 10.4894C13.8427 10.1094 13.296 9.79167 12.5682 10.3411C12.5682 10.3411 11.5855 11.0939 10.0005 11.0939C8.41491 11.0939 7.43268 10.3411 7.43268 10.3411C6.70546 9.78889 6.15657 10.1094 5.95602 10.4894Z" fill="white"/>
      <path d="M9.99932 10.0789C11.9315 10.0789 13.5093 8.56887 13.5093 6.70998C13.5093 4.84331 11.9315 3.33331 9.99932 3.33331C8.06655 3.33331 6.48877 4.84331 6.48877 6.70998C6.48877 8.56887 8.06655 10.0789 9.99932 10.0789ZM9.99932 5.04387C10.9488 5.04387 11.7232 5.78887 11.7232 6.70998C11.7232 7.62331 10.9488 8.36831 9.99932 8.36831C9.04988 8.36831 8.27544 7.62331 8.27544 6.70998C8.27488 5.78831 9.04932 5.04387 9.99932 5.04387Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="3.33325" y="3.33331" width="13.3333" height="13.3333" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ShareOK'
}
</script>
